export default {
  namespaced: true,
  state: {
    currentScreen: 'main-screen',
    currentLeftSpacer: '',
    currentRightSpacer: '',
    logs: false,
    developMode: process.env.NODE_ENV !== 'production',
  },
  mutations: {
    setLeftSpacer(state, data) {
      state.currentLeftSpacer = data
    },
    setRightSpacer(state, data) {
      state.currentRightSpacer = data
    },
  },
  actions: {
    setLeftSpacer({ commit }, data) {
      commit('setLeftSpacer', data);
    },
    setRightSpacer({ commit }, data) {
      commit('setRightSpacer', data);
    },
  },
}